<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container" *ngFor="let item of filter.getValues(); let idx = index; trackBy: trackByFunc">
		<mat-icon color="accent" mat-ripple class="circle-icon-remove" svgIcon="md:remove" (click)="removeValue(idx)"
		*ngIf="!isDefaultFilter"></mat-icon>
		<mat-form-field appearance="outline" class="copo-no-error-message">
			<input matInput [placeholder]="filter.placeholder" [ngModel]="filter.getValues()[idx]" (ngModelChange)="filter.getValues()[idx] = $event" [attr.aria-label]="filter.label" />
		</mat-form-field>
	</div>
</ng-container>
